/**
 * The motion scale, for the callers that cannot read `var()`.
 *
 * `motion/react` takes numbers, so the values in `globals.css` have to exist a
 * second time here. The duplication is deliberate and bounded: it is the only
 * copy, and `src/app/__tests__/design-tokens.test.ts` fails if it drifts from
 * the stylesheet. Anything that *can* read the custom property should read it
 * instead of importing from this file.
 */

/** Mirrors `--tb-duration-1..5`, in milliseconds. */
export const TB_DURATION_MS = {
  1: 120,
  2: 220,
  3: 360,
  4: 600,
  5: 420,
} as const;

/** Mirrors `--tb-ease-linen` — the default for UI (hover, focus, surfaces). */
export const TB_EASE_LINEN = [0.32, 0.08, 0.24, 1] as const;

/** Mirrors `--tb-ease-quill` — full-screen transitions only. */
export const TB_EASE_QUILL = [0.45, 0, 0.15, 1] as const;

/** Mirrors `--tb-ease-out` — large editorial reveals. */
export const TB_EASE_OUT = [0.22, 0.61, 0.36, 1] as const;

/** Mirrors `--tb-rise-distance`, in pixels: content answering an action. */
export const TB_RISE_DISTANCE_PX = 14;

/** Mirrors `--tb-reveal-distance`, in pixels: editorial, scroll-driven. */
export const TB_REVEAL_DISTANCE_PX = 28;

/**
 * A smooth scroll to a place in the page (Motion Guide §4, the reference's `navScroll`): the
 * target lands 88px down, clear of the 75px sticky header, over 1.2s on an out-cubic curve.
 * Not a stylesheet value — only Lenis reads it.
 */
export const TB_SCROLL_TO = { offsetPx: 88, durationS: 1.2 } as const;

/** The out-cubic curve of {@link TB_SCROLL_TO}. */
export function easeOutCubic(progress: number): number {
  return 1 - Math.pow(1 - progress, 3);
}
